import { jsx as _jsx } from "react/jsx-runtime";
import { useMediaQuery } from '@mui/material';
import { FormFlex, FormFlexItem } from '../FormGrid';
import { Tag } from '../Tag';
export const TagGroup = ({ tags }) => {
    const matchBreakpoint = useMediaQuery((theme) => theme.breakpoints.up('md'));
    return (_jsx(FormFlex, { rowGap: matchBreakpoint ? 2 : 1, columnGap: matchBreakpoint ? 2 : 1, children: tags.map((tag, i) => (_jsx(FormFlexItem, { width: "auto", flexGrow: 0, children: _jsx(Tag, { ...tag }) }, i))) }));
};
